export class ListDataCatalogPipelinesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "state",
            "baseName": "state",
            "type": "DataCatalogPipelineState",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogPipelinesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
